import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiCheckbox(_theme: Theme): MuiThemeComponentOverride<"MuiCheckbox"> {
  return {
    MuiCheckbox: {
      defaultProps: {
        color: "primary",
      },
    },
  };
}
